import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type AnimalTypeCategory = {
    id: number
    title: string,
    value: string,
    image: string,
    tags: number[],
    icon: string,
    animal_types_category: any
}

export type AnimalTypeCategoryDto = {
    title: string,
    value: string,
    image: string,
    tags: number[],
    icon: string
}

export const AnimalTypeCategoriesApi = createApi({
    reducerPath: 'AnimalTypeCategoriesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["ANIMAL-TYPE-CATEGORY"],
    endpoints: builder => ({
        getAllAnimalTypeCategories: builder.query<AnimalTypeCategory[], void>({
            query: () => ({ url: `/animal-types-category` }),
            providesTags: ["ANIMAL-TYPE-CATEGORY"],
        }),
        getAllAnimalTypeCategoriesEn: builder.query<AnimalTypeCategory[], void>({
            query: () => ({ url: `/animal-types-category?lang=en` }),
            providesTags: ["ANIMAL-TYPE-CATEGORY"],
        }),
        getAnimalTypeCategory: builder.query<AnimalTypeCategory, { id: number }>({
            query: ({ id }) => ({ url: `/animal-types-category/${id}` }),
            providesTags: ["ANIMAL-TYPE-CATEGORY"],
        }),
        createAnimalTypeCategory: builder.mutation<any, AnimalTypeCategoryDto>({
            query: (data) => ({url: `/animal-types-category`, method: "POST", body: data}),
            invalidatesTags: ["ANIMAL-TYPE-CATEGORY"],
        }),
        deleteAnimalTypeCategoriesByIds: builder.mutation<any, any>({
            query: (data)=> ({url: `/animal-types-category/delete-by-ids/del`, method: "POST", body: data}),
            invalidatesTags: ["ANIMAL-TYPE-CATEGORY"],
        }),
        updateAnimalTypeCategory: builder.mutation<any, any>({
            query: data => ({ url: `/animal-types-category/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ["ANIMAL-TYPE-CATEGORY"],
        }),
        updateAnimalTypesCategoryEn: builder.mutation<any, any>({
            query: data => ({ url: `/animal-types-category/en/update/${data.id}`, method: 'PATCH', body: {title: data.title, value: data.value} }),
            invalidatesTags: ["ANIMAL-TYPE-CATEGORY"]
        }),
    })
})

export const { useGetAllAnimalTypeCategoriesQuery, useGetAllAnimalTypeCategoriesEnQuery, useGetAnimalTypeCategoryQuery, useCreateAnimalTypeCategoryMutation, useDeleteAnimalTypeCategoriesByIdsMutation, useUpdateAnimalTypeCategoryMutation, useUpdateAnimalTypesCategoryEnMutation } = AnimalTypeCategoriesApi
